import { render, staticRenderFns } from "./OrcamentoEditar.vue?vue&type=template&id=60355cde"
import script from "./OrcamentoEditar.vue?vue&type=script&lang=js"
export * from "./OrcamentoEditar.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoEditar.vue?vue&type=style&index=0&id=60355cde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports